module.exports = __webpack_public_path__ + "img/stapel-text-02.f3c5939b.svg";